import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faYoutube, faFacebook } from '@fortawesome/free-brands-svg-icons';
import './Footer.css';

const Footer = React.memo(() => {
  return (
    <footer className="footer" role="contentinfo">
      <div className="footer-container">
        <div className="footer-left">
          <div className="footer-logo-text">
            <img
              src="/images/logo-white.png"
              alt="MonkeyFit Logo"
              className="footer-logo"
              width="240"
              height="75"
            />
            <h2 className="footer-tagline">Entrena, medita y come saludable</h2>
          </div>
          <p className="footer-contact">¡Mantengamos el contacto!</p>
          <nav className="footer-social" aria-label="Redes sociales">
            <a
              href="https://www.instagram.com/monkeyfitpass"
              aria-label="Visita nuestro Instagram"
              rel="noopener noreferrer"
              target="_blank"
            >
              <FontAwesomeIcon icon={faInstagram} />
            </a>
            <a
              href="https://www.youtube.com/@monkeyfit"
              aria-label="Visita nuestro canal de YouTube"
              rel="noopener noreferrer"
              target="_blank"
            >
              <FontAwesomeIcon icon={faYoutube} />
            </a>
            <a
              href="https://www.facebook.com/monkeyfitpass"
              aria-label="Visita nuestro Facebook"
              rel="noopener noreferrer"
              target="_blank"
            >
              <FontAwesomeIcon icon={faFacebook} />
            </a>
          </nav>
        </div>
        <div className="footer-right">
          <nav className="footer-links" aria-label="Enlaces del sitio">
            <a href="https://www.monkeyfitpass.com/company" rel="noopener noreferrer">
              Compañía
            </a>
            <a href="https://www.monkeyfitpass.com/legal" rel="noopener noreferrer">
              Legal
            </a>
          </nav>
          <div className="footer-app-buttons">
            <p className="footer-app-label">Encuéntranos en:</p>
            <a
              href="https://play.google.com/store/apps/details?id=com.monkeyfit"
              aria-label="Descarga nuestra app en Google Play"
              rel="noopener noreferrer"
              target="_blank"
            >
              <img
                src="https://static.monkeyfitpass.com/images/empleados/google.png"
                alt="Disponible en Google Play"
                width="130"
                height="auto"
              />
            </a>
            <a
              href="https://apps.apple.com/app/monkeyfit"
              aria-label="Descarga nuestra app en App Store"
              rel="noopener noreferrer"
              target="_blank"
            >
              <img
                src="https://static.monkeyfitpass.com/images/empleados/apple.png"
                alt="Disponible en App Store"
                width="130"
                height="auto"
              />
            </a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} MonkeyFit. Todos los derechos reservados.</p>
      </div>
    </footer>
  );
});

Footer.displayName = 'Footer';

export default Footer;
